import { C as CosmosMediaPreview$1, d as defineCustomElement$1 } from './p-7775b950.js';

const CosmosMediaPreview = CosmosMediaPreview$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosMediaPreview, defineCustomElement };
